// Copyright (c) 2017 Deere & Company

import SelectedSpaLevels from '../state/selected-spa-levels';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateSelectedSpaLevels = (state, action) =>
    SelectedSpaLevels.update(state, {
        $set: action.selectedSpaLevels
    });

export default (state = getDefaultState().selectedSpaLevels, action) => {

    const actionTypes = {
        [actions.UPDATE_TABM_WIP_SELECTED_SPA_LEVELS]: updateSelectedSpaLevels
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/tabm/wip/reducers/selected-spa-levels.js